export const copyToClipboard = async (
    copyToClipboard: string,
): Promise<void> => {
    await navigator.clipboard.writeText(copyToClipboard);
};
